import RidingResult from './RidingResult'
import MultiSeatResult from './MultiSeatResult'
import Province from './Province'

export default class ProvincialResult extends MultiSeatResult {
  protected _province: Province

  protected static filterRidingResults(
    ridingResults: RidingResult[],
    province: Province
  ): RidingResult[] {
    return ridingResults.filter(
      (r: RidingResult): boolean => r.riding.province.key === province.key
    )
  }

  public constructor(ridingResults: RidingResult[], province: Province) {
    super(ProvincialResult.filterRidingResults(ridingResults, province))
    this._province = province
  }

  public get province(): Province {
    return this._province
  }
}
